import { userOfflineModel } from "@/core/modules/user/models/UserOfflineModel";

export const coreOfflineModules = [userOfflineModel];
